export default __webpack_public_path__ + "static/media/Montserrat-Regular.9ef702d4.woff";